import { createSlice } from "@reduxjs/toolkit";

const apptoken =
  localStorage.getItem("applicationToken") !== null
    ? JSON.parse(localStorage.getItem("applicationToken"))
    : ""; // localStorage'dan apptoken al

const initialState = {
  apptoken: apptoken,
};

export const applicationToken = createSlice({
  name: "apptoken",
  initialState,
  reducers: {
    changeAppToken: (state, action) => {
      state.apptoken = action.payload; // action.payload ile güncelle
      localStorage.setItem("applicationToken", JSON.stringify(action.payload)); // localStorage'a kaydet
    },
    getApptoken: (state) => {
      return state.apptoken; // apptoken döndür
    },
  },
});

export const { changeAppToken, getApptoken } = applicationToken.actions;
export default applicationToken.reducer;